// extracted by mini-css-extract-plugin
module.exports = {"root":"ConfirmModal_root__26rpw","body":"ConfirmModal_body__1q0WF","text":"ConfirmModal_text__25otK","footer":"ConfirmModal_footer__3u7oH"};